module.exports = __webpack_public_path__ + "mr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mr.svg
// module id = 959
// module chunks = 0